import { render, staticRenderFns } from "./DiscountManagerAdd.template.vue?vue&type=template&id=e290a0bc&scoped=true&"
var script = {}
import style0 from "./DiscountManagerAdd.template.vue?vue&type=style&index=0&id=e290a0bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e290a0bc",
  null
  
)

export default component.exports